var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1080(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 57,
    viewBox: "0 0 46 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H0V10H10V0Z",
    fill: "#B5B5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 0H14V2H46V0Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 6H14V8H46V6Z",
    fill: "#B5B5B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10H14V12H46V10Z",
    fill: "#B5B5B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 57H0V50H15.54V57ZM1 56H14.54V51H1V56Z",
    fill: "#B5B5B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 16H0V46H46V16Z",
    fill: "#B5B5B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1080);
export default __webpack_public_path__ + "static/media/1080.a91866fe.svg";
export { ForwardRef as ReactComponent };